import "./Text.scss";

import { FC, ReactNode } from "react";

export interface TextProps {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  center?: boolean;
  opacity?: number;
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  h6?: boolean;
  li?: boolean;
  p?: boolean;
}

interface TextEltProps {
  children: ReactNode;
  className?: string;
  opacity?: number;
}

export const H1: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h1 style={{ opacity: opacity }} className={className}>
    {children}
  </h1>
);

export const H2: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h2 style={{ opacity: opacity }} className={className}>
    {children}
  </h2>
);

export const H3: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h3 style={{ opacity: opacity }} className={className}>
    {children}
  </h3>
);

export const H4: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h4 style={{ opacity: opacity }} className={className}>
    {children}
  </h4>
);

export const H5: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h5 style={{ opacity: opacity }} className={className}>
    {children}
  </h5>
);

export const H6: FC<TextEltProps> = ({ children, className, opacity }) => (
  <h6 style={{ opacity: opacity }} className={className}>
    {children}
  </h6>
);

export const LI: FC<TextEltProps> = ({ children, className, opacity }) => (
  <li style={{ opacity: opacity }} className={className}>
    {children}
  </li>
);

export const P: FC<TextEltProps> = ({ children, className, opacity }) => (
  <p style={{ opacity: opacity }} className={className}>
    {children}
  </p>
);

export const Text: FC<TextProps> = ({
  children,
  className,
  noPadding,
  center,
  opacity = 1,
  h1 = false,
  h2 = false,
  h3 = false,
  h4 = false,
  h5 = false,
  h6 = false,
  li = false,
  p = false
}) => {
  const classNameCombined = `${className ? className + " " : ""}${
    noPadding ? "no-padding" : ""
  } ${center ? "center" : ""}`;
  return (
    <>
      {h1 && (
        <H1 className={classNameCombined} opacity={opacity}>
          {children}
        </H1>
      )}
      {h2 && (
        <H2 className={classNameCombined} opacity={opacity}>
          {children}
        </H2>
      )}
      {h3 && (
        <H3 className={classNameCombined} opacity={opacity}>
          {children}
        </H3>
      )}
      {h4 && (
        <H4 className={classNameCombined} opacity={opacity}>
          {children}
        </H4>
      )}
      {h5 && (
        <H5 className={classNameCombined} opacity={opacity}>
          {children}
        </H5>
      )}
      {h6 && (
        <H6 className={classNameCombined} opacity={opacity}>
          {children}
        </H6>
      )}
      {li && (
        <LI className={classNameCombined} opacity={opacity}>
          {children}
        </LI>
      )}
      {p && (
        <P className={classNameCombined} opacity={opacity}>
          {children}
        </P>
      )}
    </>
  );
};

export default Text;
